import { render, staticRenderFns } from "./BotaoNoticias.vue?vue&type=template&id=14ddc6e0&lang=pug"
import script from "./BotaoNoticias.vue?vue&type=script&lang=js"
export * from "./BotaoNoticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports